import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import { ERouteLinks } from 'models/route';
import { EIconTypes } from 'constants/Icons';
import { Grid, Typography } from '@mui/material';
import { colors } from 'theme/colors';
import Icon from 'components/atoms/Icon/Icon';
import { StyledCardLink, StyledCardLinkIcon } from './styles';

interface IBoxLink extends PropsWithChildren<{}> {
  link: ERouteLinks;
  textLink: string;
  text?: string;
}

const BoxLink = ({ children, link, textLink, text }: IBoxLink) => (
  <StyledCardLink>
    <Grid item gap="4px">
      <Typography variant="body1">
        <Link to={link}>{textLink}</Link>
      </Typography>
      {text && <Typography variant="body1">{text}</Typography>}
      {children}
    </Grid>
    <Link to={link}>
      <StyledCardLinkIcon>
        <Icon type={EIconTypes.arrowRightLink} color={colors.blue600} />
      </StyledCardLinkIcon>
    </Link>
  </StyledCardLink>
);

export default BoxLink;
